import React, { useState, useEffect } from "react";
import { Modal, Button, Form, Row, Col } from "react-bootstrap";
import { NumericFormat } from 'react-number-format';
import { useCookies } from 'react-cookie';
import axios from "axios";
import Notifications, { notify } from "react-notify-toast";
import { format } from "../../../core/number";

const VentaView = ({ show, handleClose, data, edit, callback }) => {

    const [cookie, setCookies, removeCookie] = useCookies(['kUserSession']);
    const [loading, setLoading] = useState(false);
    const [updateLoading, setUpdateLoading] = useState(false);

    const [idVenta, setIdVenta] = useState(data != undefined ? data.id_venta : undefined);
    const [idMovimiento, setIdMovimiento] = useState(data != undefined ? data.id_movimiento : undefined);    
    const [date, setDate] = useState(data != undefined ? data.fecha_movimiento : undefined);
    const [nroGuia, setNroGuia] = useState(data != undefined ? data.nro_guia : undefined);
    const [tipoVenta, setTipoVenta] = useState(data != undefined ? data.tipo_venta : undefined);
    const [retiro, setRetiro] = useState(data != undefined ? data.retiro.nombre : undefined);
    const [category, setCategory] = useState(data != undefined ? data.categoria.id_categoria : undefined);
    const [carimbo, setCarimbo] = useState(data != undefined ? data.carimbo : undefined);
    const [cantidad, setCantidad] = useState(data != undefined ? data.cantidad : undefined);
    const [cliente, setCliente] = useState(data != undefined ? data.cliente.id : undefined);
    const [pesoTotal, setPesoTotal] = useState(data != undefined ? data.peso_bruto_total : undefined);
    const [pesoTotalFrigorifico, setPesoTotalFrigorifico] = useState(data != undefined ? data.peso_total_frigorifico : undefined);
    const [observation, setObservation] = useState(data != undefined ? data.observacion : undefined);

    const [categories, setCategories] = useState([]);
    const [customers, setCustomers] = useState([]);

    const [owner, setOwner] = useState(data != undefined ? data.owner : undefined);
    const [owners, setOwners] = useState([]);

    const [creationDate, setCreation] = useState(data != undefined ? data.fecha_movimiento : undefined);
    const [userCreation, setUserCreation] = useState(data != undefined ? data.usuario_creacion.email : undefined);
    const [userLastModification, setUserLastModification] = useState(data != undefined ? data.usuario_ultima_modificacion.email : undefined);

    const prepareHeaders = () => {
        return {
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                "Access-Control-Allow-Origin": "*",
                "api_key": "k-randa",
                "access_token": cookie.kUserSession.data.access_token
            }
        };
    }      

    const retrieveOwners = () => {
        let company = cookie.kUserSession.data["company"];
        axios.get(process.env.REACT_APP_API_URL + "owners?company_id=" + company.id , prepareHeaders())
        .then(rs => {
            if(rs.status == 200){
                let data = rs.data;
                setOwners(data);
                setOwner(data[0]);
            }
            else {
                setOwners([]);
                setOwner(undefined);
            }
        })
        .catch(error => {
            console.error(error);
            setOwners([]);
            setOwner(undefined);
        });
    }        

    useEffect(() => {
        retrieveCustomers();
        retrieveCategories();
        retrieveOwners();
    }, []);

    useEffect(() => {
        console.log(data);
        setIdVenta(data != undefined ? data.id_venta : undefined);
        setIdMovimiento(data != undefined ? data.id_movimiento : undefined);        
        setDate(data != undefined ? data.fecha_movimiento : undefined);
        setNroGuia(data != undefined ? data.nro_guia : undefined);
        setTipoVenta(data != undefined ? data.tipo_venta : undefined);
        setRetiro(data != undefined ? data.retiro.nombre : undefined);
        setCategory(data != undefined ? data.categoria.id_categoria : undefined);
        setCarimbo(data != undefined ? data.carimbo : undefined);
        setCantidad(data != undefined ? data.cantidad : undefined);
        setCliente(data != undefined ? data.cliente.id : undefined);
        setPesoTotal(data != undefined ? data.peso_bruto_total : undefined);
        setPesoTotalFrigorifico(data != undefined ? data.peso_total_frigorifico : undefined);
        setObservation(data != undefined ? data.observacion : undefined);
        setCreation(data != undefined ? data.fecha_movimiento : undefined);
        setUserCreation(data != undefined ? data.usuario_creacion.email : undefined);
        setUserLastModification(data != undefined ? data.usuario_ultima_modificacion.email : undefined);
        setOwner(data != undefined ? data.owner : undefined);        
    }, [data]);

    const retrieveCategories = () => {
        axios.get(process.env.REACT_APP_API_URL + "category", prepareHeaders())
        .then(rs => {
            console.log(rs);
            if(rs.status == 200){
                let {data} = rs.data;
                setCategories(data);
            }
            else {
                setCategories([]);
            }            
        })
        .catch(error => {
            console.error(error);
            setCategories([]);
        });
    }

    const retrieveCustomers = () => {
        //setLoading(true);
        axios.get(process.env.REACT_APP_API_URL + "customer", prepareHeaders())
        .then(rs => {
            console.log(rs);
            if(rs.status == 200){
                let { data } = rs.data;
                console.log(data);
                //setLoading(false);
                setCustomers(data);
            }
            else {
                //setLoading(false);
                setCustomers([]);
            }
        })
        .catch(error => {
            console.error(error);
            //setLoading(false);
            setCustomers([]);
        });
    }    

    const handleUpdate = (e) => {
        var currentFarm = cookie.kUserSession.data["farm"];
        var data = {
            data: {
                id_venta: idVenta,
                id_movimiento: idMovimiento,
                cantidad: parseInt(cantidad),
                carimbo: parseInt(carimbo),
                fecha_movimiento: date,
                id_categoria: parseInt(category),
                id_cliente: parseInt(cliente),
                id_estancia: currentFarm.id,
                nro_guia: parseInt(nroGuia),
                observacion: observation,
                peso_bruto_total: parseInt(pesoTotal),
                peso_total_devastado: pesoTotal * 0.96,
                peso_total_frigorifico: parseInt(pesoTotalFrigorifico),
                retiro: retiro,
                tipo_venta: tipoVenta,
                owner: owner ? owner.id : undefined
            }
        }
        update(data);        
    }

    const update = (data) => {
        setUpdateLoading(true);
        axios.put(process.env.REACT_APP_API_URL + "movements/outcome/sale", data, prepareHeaders())
        .then(rs => {
            console.log(rs);
            if(rs.status == 200){
                notify.show("Se ha actualizado la información exitosamente", "success");
                setUpdateLoading(false);
                handleClose();
                callback();
            }
            else {
                setUpdateLoading(false);
                notify.show("Ha ocurrido un error al actualizar la información", "error");
                handleClose();
                callback();
            }
        })
        .catch(error => {
            console.error(error);
            setUpdateLoading(false);
            notify.show("Ha ocurrido un error al actualizar la información", "error");
            handleClose();
            callback();
        })        
    }

    return (
        <>
            <Notifications />
            <Modal show={show} onHide={handleClose} size="lg">
                <Modal.Header closeButton>
                    <Modal.Title><b>Datos de la venta</b></Modal.Title>
                </Modal.Header>
                <Modal.Body>
                <Form>
                        <Row>
                            <Col>
                                <Form.Group controlId="fecha_gasto">
                                    <Form.Label>Fecha</Form.Label>
                                    <Form.Control disabled={!edit} value={date} onChange={(e) => { setDate(e.target.value); }} type="date" />
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group controlId="nro_guia">
                                    <Form.Label>N° Guía</Form.Label>
                                    <Form.Control disabled={!edit} value={nroGuia} onChange={(e) => { setNroGuia(e.target.value); }} type="number" placeholder="Ingrese la guía" />
                                </Form.Group>                        
                            </Col>

                            <Col>
                                <Form.Group controlId="nro_cota">
                                    <Form.Label>Tipo de venta</Form.Label>
                                    <Form.Control disabled={!edit} value={tipoVenta} onChange={(e) => { setTipoVenta(e.target.value); }} as="select">
                                        <option value={"P"}>EN PIE</option>
                                        <option value={"E"}>FERIA</option>
                                        <option value={"F"}>FRIGORIFICO</option>
                                    </Form.Control>
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group controlId="categoria">
                                    <Form.Label>Zona</Form.Label>
                                    <Form.Control disabled={!edit} value={retiro} onChange={(e) => { setRetiro(e.target.value); }} type="text"/>
                                </Form.Group>
                            </Col>                               
                        </Row>
                        <Row>
                            <Col>
                                <Form.Group controlId="categoria">
                                    <Form.Label>Categoría</Form.Label>
                                    <Form.Control disabled={!edit} value={category} onChange={(e) => { setCategory(e.target.value); }} as="select">
                                        <option value={0} selected disabled>Seleccione la categoría</option>
                                        {
                                            categories.map((i) => (
                                                <option value={i.id_categoria}>{i.nombre}</option>
                                            ))
                                        }
                                    </Form.Control>
                                </Form.Group>                        
                            </Col>
                            <Col>
                                <Form.Group controlId="carimbo">
                                    <Form.Label>Carimbo</Form.Label>
                                    <Form.Control disabled={!edit} value={carimbo} onChange={(e) => { setCarimbo(e.target.value); }} type="number" />
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group controlId="cantidad_sobre_guia">
                                    <Form.Label>Cantidad</Form.Label>
                                    <Form.Control disabled={!edit} value={cantidad} onChange={(e) => { setCantidad(e.target.value); }} type="number" />
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Form.Group controlId="proveedor">
                                    <Form.Label>Cliente</Form.Label>
                                    <Form.Control disabled={!edit} value={cliente} onChange={(e) => { setCliente(e.target.value); }} as="select">
                                        <option value={0} selected disabled>Seleccione el cliente</option>
                                        {
                                            customers.map((i) => (
                                                <option value={i.id}>{i.razon_social}</option>
                                            ))
                                        }
                                    </Form.Control>
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group controlId="owner">
                                    <Form.Label>Propietario</Form.Label>
                                    <Form.Control disabled={!edit}  as="select" value={ owner != undefined ? owner.id : undefined} onChange={(e) => {setOwner({...owner, id: e.target.value});}}>
                                        <option value={0} selected disabled>Seleccione el propietario</option>
                                        {
                                            owners.map((i) => (
                                                <option value={i.id}>{i.nombres + " " + i.apellidos}</option>
                                            ))
                                        }
                                    </Form.Control>
                                </Form.Group>
                            </Col>                            
                        </Row>
                        <Row>
                            <Col>
                                <Form.Group controlId="peso_total">
                                    <Form.Label>Peso total</Form.Label>
                                    <NumericFormat
                                        disabled={!edit}
                                        className="karanda-input"
                                        value={pesoTotal}
                                        customInput={Form.Control}
                                        thousandSeparator="."
                                        decimalSeparator="," 
                                        decimalScale={2}
                                        allowNegative={false}
                                        onValueChange={(v) => { setPesoTotal(v.floatValue); }}
                                    />
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group controlId="peso_total">
                                    <Form.Label>Peso total frigorifico</Form.Label>
                                    <NumericFormat
                                        disabled={!edit}
                                        className="karanda-input"
                                        value={pesoTotalFrigorifico}
                                        customInput={Form.Control}
                                        thousandSeparator="."
                                        decimalSeparator="," 
                                        decimalScale={2}
                                        allowNegative={false}
                                        onValueChange={(v) => { setPesoTotalFrigorifico(v.floatValue); }}
                                    />
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={12} style={{textAlign: "right"}}>
                                <span><strong>Peso promedio: </strong> {format(pesoTotal / cantidad, 2)}</span>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={12} style={{textAlign: "right"}}>
                                <span><strong>Peso total devastado (4%): </strong> {format(pesoTotal * 0.96, 2)}</span>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={12} style={{textAlign: "right"}}>
                                <span><strong>Rendimiento (%): </strong> {pesoTotalFrigorifico ? format((pesoTotalFrigorifico * 100) / (pesoTotal * 0.96), 2) : '-'}</span>
                            </Col>
                        </Row>                        
                        <Row>
                            <Col>
                                <Form.Group controlId="observacion">
                                    <Form.Label>Observación</Form.Label>
                                    <Form.Control disabled={!edit} value={observation} onChange={(e) => {setObservation(e.target.value); }} type="text" />
                                </Form.Group>
                            </Col>
                        </Row>
                        {
                            edit ? (<></>) : (
                                <>
                                    <Row>
                                        <Col>
                                            <Form.Group controlId="creador">
                                                <Form.Label>Creador</Form.Label>
                                                <Form.Control value={userCreation} disabled type="email" />
                                            </Form.Group>
                                        </Col>
                                        <Col>
                                            <Form.Group controlId="modificador">
                                                <Form.Label>Modificador</Form.Label>
                                                <Form.Control value={userLastModification} disabled type="email" />
                                            </Form.Group>                                
                                        </Col>                     
                                    </Row>
                                    <Row>
                                        <Col>
                                            <Form.Group controlId="creacion">
                                                <Form.Label>Creación</Form.Label>
                                                <Form.Control value={creationDate} disabled type="date" />
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                </>                                    
                            )
                        }
                    </Form>                    
                </Modal.Body>
                <Modal.Footer>
                    {
                        edit 
                        ? (<Button variant="primary" onClick={handleUpdate}>Actualizar</Button>)
                        : (<></>)
                    }
                    <Button variant="secondary" onClick={handleClose}>Cerrar</Button>
                </Modal.Footer>
            </Modal>
        </>
    );

};

export default VentaView;